<template>
  <Dialog
    :visible.sync="visible"
    :title="options.title"
    :content="options.content"
    :confirmText="options.confirmText"
    :cancelText="options.cancelText"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  >
    <div class="confirm-content">
      <p>
        {{ options.content }}
      </p>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '../dialog/index.vue'
export default {
  name: 'Confirm',
  components: {
    Dialog,
  },
  data() {
    return {
      visible: false,
      options: {
        title: '',
        content: '',
        confirmText: '',
        cancelText: '',
        confirm: () => {},
        cancel: () => {},
      },
    }
  },
  created() {},
  methods: {
    handleConfirm() {
      this.close()
      this.options.confirm()
    },
    handleCancel() {
      this.close()
      this.options.cancel()
    },
    close() {
      this.visible = false
    },
    open(options) {
      this.options = {
        ...this.options,
        ...options,
      }
      this.visible = true
    },
  },
}
</script>

<style lang="less" scoped>
.confirm-content {
  border-radius: 0.2133rem;
  background: rgba(242, 244, 248, 1);
  font-size: 0.4267rem;
  line-height: 1.3;
  color: rgba(52, 58, 63, 1);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    min-height: 2.1333rem;
    max-height: 8rem;
    height: 100%;
    overflow-y: auto;
    text-align: center;
    padding: 0.32rem;
  }
}
</style>
